import { Component } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import {BiblioPage} from "../biblio/biblio";
import {AcknowledgmentsPage} from "../acknowledgments/acknowledgments";
import {AuthService} from "../../services/authService";
import {MailLoginPage} from "../mail-login/mail-login";
import {UsagePage} from "../usage/usage";

/**
 * Generated class for the WelcomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: 'welcome',
  name: 'welcome'
})
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {

  constructor(public navCtrl: NavController,
              private auth: AuthService,
              private modalCtrl: ModalController,
              public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

  login() {
    // Check that the user has already inserted his email
    this.auth.isLoggedIn().then(
      logged => {
        if (logged) {
          this.navCtrl.push('InsertPatientData')
        } else {
          this.openLoginModal();
        }
      }
    )
  }

  openLoginModal() {
    const modal = this.modalCtrl.create(MailLoginPage);
    modal.present();
  }

  goToAck() {
    this.navCtrl.push(AcknowledgmentsPage);
  }

  goToBiblio() {
    this.navCtrl.push(BiblioPage);
  }

  goToUsage() {
    this.navCtrl.push(UsagePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts